import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import fontOptions from '../../common/font-options/font-options.esm.js';

/*
 * Color assignment of text is usually very context base on the specific lay out and where it is being used,
/* thus we want by default to allow the consumer to past the text color requirements through css color inheritance.
/* This will allow a most robust way to consume of the text element. This is the same concept apply
/* to svg element via the `color: current-color` assignment. Taking this approach will avoid lots of unnecessary
/* override for every use text element, however the consumer always have the option to assign specific color
/* with override tailwind text color classes or the specific color props made available via TextProps.
*/
var textTV = getTvObject({
  base: 'm-0 text-inherit',
  // Please don't change the default color assignment here, see the note above.
  variants: _objectSpread2({}, fontOptions)
});
var base = tv(textTV);
var textStyles = {
  base: base
};

export { textStyles, textTV };
//# sourceMappingURL=text.styles.esm.js.map
